import { WorkflowPromptSubmissionStatus as D2Status } from '../../../types';
import { WorkflowPromptSubmissionStatusRaw as RawStatus } from '../../types';

/** Mapping from the raw statuses used by WFS to the D2 statuses. */
export const workflowStatusMapping: {
  [K in keyof(typeof RawStatus) as typeof RawStatus[K]]: typeof D2Status[K];
} = {
  [RawStatus.failure]: D2Status.failure,
  [RawStatus.inProgress]: D2Status.inProgress,
  [RawStatus.success]: D2Status.success
};
